<h1 mat-dialog-title>{{ "Please confirm" | cmLocalize: locFeature +
	"/_Shared.UnsavedConfirmation.Title.Confirm" }}
</h1>
<div mat-dialog-content>
	<p>{{ "Unsaved changes will be lost." | cmLocalize: locFeature +
		"/_Shared.UnsavedConfirmation.Content.Unsaved"
		}}</p>
</div>
<div mat-dialog-actions>
	<button (click)="onNoClick()">{{ "Cancel" | cmLocalize: locFeature +
		"/_Shared.UnsavedConfirmation.Button.Cancel" }}</button>
	<button [mat-dialog-close]="true" color="primary" cdkFocusInitial>{{ "Continue" | cmLocalize: locFeature
		+
		"/_Shared.UnsavedConfirmation.Button.Continue" }}</button>
</div>
